<template>
  <pt-holiday-excel-new class="pt-holiday-excel-new__withData"></pt-holiday-excel-new>
</template>

<script>
import PtHolidayExcelNew from './index'
export default {
  name: 'pt-holiday-excel-new__withData',
  components: {
    'pt-holiday-excel-new': PtHolidayExcelNew
  }
}
</script>
